import { Component, Input } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input() width: number = 100;
  @Input() height: number = 100;
  options: AnimationOptions = {
    path: 'assets/loading-animation.json',
  };
}
